// src/hooks/pricingUnits/useRestoreAllPricingUnits.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllPricingUnits } from "../../api/apiPricingUnits";
import parseError from "../../utils/parseError";

const useRestoreAllPricingUnits = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllPricingUnitsMutation,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: restoreAllPricingUnits,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["pricingUnits"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore pricing units");
        },
    });

    return {
        restoreAllPricingUnits: restoreAllPricingUnitsMutation,
        isPending: isPending || isLoading,
    };
};

export default useRestoreAllPricingUnits;
